import { render } from "./TableForCatalog.vue?vue&type=template&id=01f7204e&scoped=true"
import script from "./TableForCatalog.vue?vue&type=script&lang=js"
export * from "./TableForCatalog.vue?vue&type=script&lang=js"

import "./TableForCatalog.vue?vue&type=style&index=0&id=01f7204e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01f7204e"]])

export default __exports__